/* tabArray.control_adapter.js */

var $ = require("jquery");
var _ = require("lodash");
var underscoreString = require("underscore.string");
_.mixin(underscoreString.exports());
var EventEmitter = require("events").EventEmitter;
var util = require("util");
var q = require("q");
var ArrayControlAdapter = require("./array.control_adapter");
/**
 * @event ArrayControlAdapter#ValueChanged
 * @type {Object}
 * @property oldValue {string} The previous value
 * @property newValue {string} The new value
 */

/**
 * @class TabArrayControlAdapter
 * @classdesc renders the Select Options Jtype.
 * @implements AngularControlAdapter
 *
 * @param logger {Bunyan} The logger
 * @param containingElem {DomElement} The containing dom element for this control
 * @param formCtrlDef {FormControlDefinition} The definition of this control object.
 *
 * @requires util
 * @requires EventEmitter
 *
 * @fires ArrayControlAdapter#ValueChanged
 */
module.exports = function TabArrayAdapter(logger, containingElem, formCtrlDef) {
    ArrayControlAdapter.call(this, logger, containingElem, formCtrlDef);
    this.templateName = "templatecache/templates/tab_array.template.html";

    var superInit = this.$init;

    this.$init = function ($scope, $templateCache, $timeout, $compile) {
        // Do the super init stuff first then
        let deferredPromise = superInit.call(this, $scope, $templateCache, $timeout, $compile);

        var tabForm = formCtrlDef;
        var tabLabel = tabForm.name;
        if (tabForm.configSettings.Display.label) {
            tabLabel = tabForm.configSettings.Display.label;
        }
        $scope.tabLabel = tabLabel;
        $scope.tabName = formCtrlDef.configSettings.tabName;
        $scope.containerTabNum = formCtrlDef.configSettings.tabNum;
        $scope.tabInfo = {};
        $scope.tabInfo[$scope.tabName] = {};
        // Initialize the tab value
        $scope.tabInfo[$scope.tabName].currentTabNum = 0;

        $scope.tabSelected = function (tabNumber) {
            $scope.tabNum = tabNumber;
            $scope.$root.$broadcast("TabChange", {
                tabName: $scope.tabName,
                tabNum: tabNumber,
            });
        };

        // Listen for a tab change on the parent.
        var tabListenerCleanup = $scope.$on("TabChange", function (tabEvent, msg) {
            if ($scope.tabName === msg.tabName) {
                $scope.tabInfo[$scope.tabName].currentTabNum = msg.tabNum;
            }
        });
        // Clean up the tab listener.
        $scope.$on("$destroy", tabListenerCleanup);
        return deferredPromise;
    };

    // Attach any objects from the base object $init function to the current object.
    let initKeys = Object.keys(superInit);
    initKeys.forEach((key) => {
        this.$init[key] = superInit[key];
    });

    /**
     * This function will attach the array object to the tab container.
     * @param containingElem
     * @param childElem
     * @private
     */
    this._attachToParentElement = function (containingElem, childElem) {
        if (this._multiEditMode) {
            var multiEditContainer = $(containingElem).find(".multi_edit_select_widget:first");
            multiEditContainer.append(childElem);
            this.arrayParentElem = multiEditContainer;
        } else {
            var tabContainer = $(containingElem).children(".tab_container");
            this.arrayParentElem = tabContainer;
            tabContainer.append(childElem);
        }
    };

    /********************************************************************************/
    /*** END Angular/Render Work                                                  ***/
    /********************************************************************************/
};
//Make this API inherit from EventEmitter
util.inherits(module.exports, EventEmitter);

//Tell the Form renderer that this is an Angular Control.
module.exports.isAngularControl = true;

//Tell the Form renderer that this adapter supports multi edit mode.
module.exports.isMultiEditSupported = true;
